import axios from 'axios';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import config from '../config';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors

    try {
      // CHANGE: Convert username to lowercase before sending to backend
      const lowercaseUsername = username.toLowerCase();
      
      const response = await axios.post(
        `${config.BASE_API_ENDPOINT}/api/token/`,
        { username: lowercaseUsername, password }, // CHANGE: Use lowercaseUsername in the request
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('Login response:', response.data);

      // Store tokens in localStorage
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);

      onLogin(response.data);
      navigate('/home');
    } catch (error) {
      console.error('Login error:', error);
      console.log('Error response:', error.response);
      // Set error message from backend or fallback
      setError(
        error.response?.data?.detail ||
        error.response?.data?.error ||
        'Invalid username or password. Please try again.'
      );
    }
  };

return (
  <div className="min-h-screen bg-background flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-md w-full">
      {/* Logo/Branding */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-2xl mb-4">
          <svg
            className="w-10 h-10 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        </div>
        <h2 className="text-3xl font-bold text-text-primary mb-2">
          Welcome to Dentara
        </h2>
        <p className="text-sm text-text-secondary">
          Sign in to manage your dental practice
        </p>
      </div>

      {/* Login Form */}
      <form
        onSubmit={handleSubmit}
        className="p-5 md:p-8 bg-white shadow-sm rounded-lg border border-border"
      >
        {error && (
          <div className="flex items-start gap-3 p-3 mb-6 bg-status-no-show/10 border border-status-no-show/30 rounded-lg">
            <svg
              className="w-5 h-5 text-status-no-show flex-shrink-0 mt-0.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <div className="flex-1">
              <p className="text-sm font-medium text-status-no-show">{error}</p>
            </div>
          </div>
        )}

        <div className="space-y-5">
          <div>
            <label
              className="block text-sm font-medium text-text-primary mb-2"
              htmlFor="username"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full min-h-11 md:min-h-0 px-4 py-2.5 border border-border rounded-lg text-text-primary placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition"
              placeholder="Enter your username"
              required
            />
          </div>

          <div>
            <label
              className="block text-sm font-medium text-text-primary mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full min-h-11 md:min-h-0 px-4 py-2.5 border border-border rounded-lg text-text-primary placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition"
              placeholder="Enter your password"
              required
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full min-h-11 md:min-h-0 mt-6 bg-primary text-white font-medium py-3 rounded-lg hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition"
        >
          Sign In
        </button>

        {/* Forgot password link */}
        <div className="mt-4 text-center">
          <Link
            to="/forgot-password"
            className="inline-block py-3 md:py-0 text-sm text-primary hover:text-primary-dark transition"
          >
            Forgot your password?
          </Link>
        </div>
      </form>
    </div>
  </div>
);
};

export default Login;
